import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useRef, useMemo, useCallback, memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { AnimatedOdd } from '../animated-odd/animated-odd';
import { Button } from '../button/button';
import { IconLock } from '../icons/icon';

import './odd.scss';

function OddUI({ className, outcomeId, odds, labelId, isLocked, isSelected, onOddsClick, dataTestId }) {
  const oddsClickCallback = useCallback(
    event => {
      event.preventDefault();
      if (!isLocked) onOddsClick(outcomeId);
    },
    [outcomeId, isLocked, onOddsClick]
  );
  const oddsWrapperRef = useRef();
  const oddLabel = useMemo(
    () => (
      <span className="sb-Odd-label">
        <FormattedMessage id={labelId} />
      </span>
    ),
    [labelId]
  );

  return (
    <Button
      ref={oddsWrapperRef}
      className={clsx(className, 'sb-Odd sb-AnimatedOdd-wrapper', isLocked ? 'isLocked' : isSelected && 'isSelected')}
      dataTestId={dataTestId}
      onClick={oddsClickCallback}>
      {oddLabel}
      {isLocked || odds === 0 ? (
        <IconLock className="sb-Odd-iconLock" />
      ) : (
        <AnimatedOdd className="sb-Odd-value" odds={odds} wrapperRef={oddsWrapperRef} />
      )}
    </Button>
  );
}

OddUI.propTypes = {
  outcomeId: PropTypes.number.isRequired,
  odds: PropTypes.number.isRequired,
  labelId: PropTypes.string.isRequired,
  isLocked: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onOddsClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

OddUI.defaultProps = {
  className: undefined,
  dataTestId: undefined,
};

export const Odd = memo(OddUI);
